import React from 'react';
import './DropDownOption.less';
import classNames from 'classnames';
import { HighlightMatch } from 'components/lists/HighlightMatch';

interface IDropDownOptionProps extends React.HTMLProps<{}> {
  id?: string;
  value?: any;
  index: number;
  onChosen: (id: string, value: any) => void;
  isChosen?: boolean;
  isFocused?: boolean;
  searchString?: string;
}

const getClassNames = (isChosen?: boolean, isFocused?: boolean) =>
  classNames('dpc-drop-down__option', {
    'dpc-drop-down__option__current': isChosen,
    'dpc-drop-down__option__focused': isFocused,
  });

/**
 * Drop down option for dropdowns and combo-boxes, etc.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function DropDownOption({
  children,
  id,
  value,
  onChosen,
  isChosen,
  isFocused,
  searchString,
}: IDropDownOptionProps) {
  // return children
  const onClick = () => onChosen(id || (children as string), value || children);
  const onKeyUp = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onChosen(id || (children as string), value || children);
    }
  };

  // this uses mouseDown to avoid race conditions between a "clicK" and an "onBlur" in the main combo implementation
  return (
    <div className={getClassNames(isChosen, isFocused)} onMouseDown={onClick} onKeyUp={onKeyUp}>
      {!isChosen && typeof children === 'string' ? (
        <HighlightMatch searchString={searchString}>{children}</HighlightMatch>
      ) : (
        children
      )}
    </div>
  );
}
